import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import withOptions from 'utils/functions/withOptions.util';

import { CLIENTS_SMSTEXT_FAILURE, CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS } from './beGetClientSmsText.types';

const bePutClientSmsText = withOptions(({ salonId, ...data }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    params: { method: 'PUT', salonId },
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    },
  },
}));

export default bePutClientSmsText;
